import parse from 'date-fns/parseISO'
import format from 'date-fns/format'

export const ensureValueIsDate = (value: Date | string): Date => {
   if (typeof value === 'string') {
      return parse(value as string)
   } else {
      return value
   }
}

export const formatDate = (value: Date | string, formatString: string): string => {
   const date = ensureValueIsDate(value)
   return format(date, formatString)
}
